import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
export default function Layout({ userData, setUserData }) {
  let naigate = useNavigate();
  let location = useLocation();
  function logOut() {
    localStorage.removeItem("Auth");
    setUserData(null);
    naigate("/login");
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <div className="flex flex-col mb-3  min-h-screen bg-image">
        <Navbar userData={userData} logOut={logOut} />
        <div className="flex-grow ">
          <Outlet  />
        </div>
      </div>
      <div className="hmt-50">
        <Footer />
      </div>
    </>
  );
}
